import classes from "./RepeatCustomerBox.module.css";
import { repeatCustomer } from "../util/AttributionAnalysis/repeatCustomer";
export default function RepeatCustomerBox({ data }) {
  console.log("repeat customer data", data);
  if (data == null || data == undefined) return <></>;  
  let percentage = data.repeatCustomerData.repeatPercent;
  return (
    <>
      <div className={classes.container}>
        <p> Repeat Customer</p>
        <div className={classes.circleContainer}>
          {" "}
          <div className={classes.circle}>
            <h2>{percentage}%</h2>
          </div>
        </div>
      </div>
    </>
  );
}
